
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 255.69 255.69"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"a","x1":"20.06","y1":"52.39","x2":"234.3","y2":"202.37","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#ef7d22"}}),_c('stop',{attrs:{"offset":".23","stop-color":"#ef741d"}}),_c('stop',{attrs:{"offset":".62","stop-color":"#ee5a10"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#ee3b00"}})])]),_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"Layer 1"}},[_c('circle',{attrs:{"cx":"127.84","cy":"127.84","r":"127.84","fill":"url(#a)"}}),_c('path',{attrs:{"fill":"#fff","d":"M110.02 65.4h-.05v13.75h55.07v41.5H76.16V190.29l13.73-.01v-55.92h88.86V65.4h-68.73z"}})])])])
          )
        }
      }
    